import css from './InlineLabelInput.module.scss';
import { Text, LabeledInput } from '@epam/promo';
import { InlineLabelInputProps } from './InlineLabelInput.model';
import { ReadonlyInput } from '../ReadonlyInput';
import { useMemo } from 'react';

const InlineLabelInput = ({
  children,
  errorText,
  isTitle = false,
  isReadonly = false,
  align = isReadonly ? 'top' : 'center',
  readonlyValue = '',
  isLink = false,
  ...props
}: InlineLabelInputProps) => {
  const datatestid = useMemo(
    () =>
      `${(props.label ?? 'input')
        .toLowerCase()
        .replaceAll(' ', '-')}-error-message`,
    [props.label],
  );

  return (
    <LabeledInput
      cx={{
        [css['inline-label']]: true,
        [css['inline-label_top']]: align === 'top',
        [css['inline-label_center']]: align === 'center',
      }}
      labelPosition="left"
      size="48"
      {...props}>
      {!isReadonly && children}

      {isReadonly && (
        <ReadonlyInput
          isLink={isLink}
          isTitle={isTitle}
          label={props.label ?? 'input'}
          value={readonlyValue ?? ''}
        />
      )}

      {errorText && (
        <Text
          color="red"
          cx={css['inline-label__error']}
          rawProps={{
            'data-testid': datatestid,
          }}>
          {errorText}
        </Text>
      )}
    </LabeledInput>
  );
};

export default InlineLabelInput;
